import React, { useState } from "react";

import cx from "classnames";

import CopyDoneIcon from "../Icon/icons/general/CopyDoneIcon";
import CopyIcon from "../Icon/icons/general/CopyIcon";

import s from "./CopyTextWidget.module.scss";

const CopyTextWidget = ({
	text,
	title = "",
	className = "",
	titleStyle = {},
}) => {
	const [isCopied, setIsCopied] = useState(false);
	const [isHover, setIsHover] = useState(false);

	const IconTag = isCopied ? CopyDoneIcon : CopyIcon;

	// ------------------------------------- METHODS -------------------------------------
	const copyToClipboard = async () => {
		setIsCopied(true);
		setIsHover(false);

		setTimeout(() => {
			setIsHover(true);
		}, 10);

		if ("clipboard" in navigator) {
			return navigator.clipboard.writeText(text);
		} else {
			return document.execCommand("copy", true, text);
		}
	};

	const closeTooltip = () => {
		setIsHover(false);
		setIsCopied(false);
	};

	return (
		<div className={s.root}>
			<div className={cx(s.title, titleStyle)}>{title}</div>

			<div
				className={s.copyWidget}
				onMouseEnter={() => setIsHover(true)}
				onMouseLeave={closeTooltip}
				onClick={copyToClipboard}
			>
				<div
					className={cx(s.text, className, isCopied ? s.valid : "")}
					onClick={copyToClipboard}
				>
					{text}
				</div>

				{isHover && (
					<div className={s.icons}>
						<IconTag color={"#289ef8"} width={16} height={16} />
					</div>
				)}
			</div>
		</div>
	);
};
export default CopyTextWidget;
